import { useEffect, useMemo, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../../common/components/dashboard_layout.component';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import AddIcon from '@mui/icons-material/Add';
import { SystemPurchaseOrderTable } from './SystemPurchaseOrderTable';
import CreateSystemPoModal from './components/CreateSystemPoModal';
// eslint-disable-next-line max-len
import { createSystemPoAuthorizedRecord } from './functions/create_system_po_authorized_record.function';
import { notify } from '../../common/functions/react-toastify.function';
import styles from './system_purchase_order_management.module.css';

const SystemPurchaseOrderManagement = () => {
  const navigate = useNavigate();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const purchaseOrderTableRef = useRef(null);
  const permissionNames = useMemo(() => {
    try {
      const stored = localStorage.getItem('permissions');
      if (!stored) {
        return [];
      }
      const parsed = JSON.parse(stored);
      return Array.isArray(parsed) ? parsed.map((p) => p.name) : [];
    } catch (error) {
      console.error('Failed to parse permissions:', error);
      return [];
    }
  }, []);

  useEffect(() => {
    if (!permissionNames.includes('System Invoice Management')) {
      navigate('/rov', { replace: true });
    }
  }, [permissionNames, navigate]);

  const handleUploadClick = () => {
    setIsCreateModalOpen(true);
  };

  const handleCreatePo = async (rows) => {
    const list = Array.isArray(rows) ? rows : [rows];
    setIsSaving(true);
    try {
      const payload = list.map((form) => ({
        po: form.po,
        po_date: form.po_date || null,
        vendor: form.vendor || null,
        total_amount: form.total_amount,
        po_delivery_date: form.po_delivery_date || null,
        type: form.type,
      }));

      const result = await createSystemPoAuthorizedRecord(payload);
      if (result.success && result.data) {
        const created = Array.isArray(result.data) ? result.data : [result.data];
        notify('success', result.message || `${created.length} PO(s) created successfully`);
        if (purchaseOrderTableRef.current?.addOrUpdatePurchaseOrders) {
          purchaseOrderTableRef.current.addOrUpdatePurchaseOrders(created);
        }
        setIsCreateModalOpen(false);
      } else {
        notify('error', result.error || 'Failed to create PO(s)');
      }
    } catch (error) {
      console.error('Create PO error:', error);
      notify('error', 'Failed to create PO. Please try again.');
    } finally {
      setIsSaving(false);
    }
  };

  const handleBackClick = () => {
    navigate('/rov');
  };

  return (
    <>
      <DashboardLayout padding={true}>
        <div className={styles['purchase-order-container']}>
          <div className={styles['purchase-order-header']}>
            <div className={styles['header-left']}>
              <div className={styles['back-icon-container']} onClick={handleBackClick}>
                <ArrowBackIosOutlinedIcon className={styles['back-icon']} />
              </div>
              <h1 className={styles['page-title']}>System Purchase Order Management</h1>
            </div>
            <button className={styles['upload-btn']} onClick={handleUploadClick}>
              <AddIcon sx={{ fontSize: 18, marginRight: '6px' }} />
              Add New PO
            </button>
          </div>

          <SystemPurchaseOrderTable ref={purchaseOrderTableRef} />

          <CreateSystemPoModal
            open={isCreateModalOpen}
            onClose={() => setIsCreateModalOpen(false)}
            onSave={handleCreatePo}
            isSaving={isSaving}
          />
        </div>
      </DashboardLayout>
    </>
  );
};

export { SystemPurchaseOrderManagement };
export default SystemPurchaseOrderManagement;
